import { memo, MouseEventHandler } from 'react';
import classNames from 'classnames';

import { I13N_CATEGORY_LOGIN } from 'Lib/constants/i13nSpec';

import TinderLogo from 'Containers/PageLayout/TinderLogoLink';
import ClickableDiv from 'Components/A11y/ClickableDiv';
import { I13nHeader } from 'Components/I13n';

import HamburgerIcon from 'Assets/reactSvgs/HamburgerIcon';

import { VARIANT_OVERLAY } from '../lib/constants';
import type { HeaderVariant } from '../types';

type Props = {
  className?: string;
  onMenuClick: MouseEventHandler;
  variant?: HeaderVariant;
};

const PageLayoutMobileHeader = ({ className, onMenuClick, variant = VARIANT_OVERLAY }: Props) => {
  const isOverlay = variant === VARIANT_OVERLAY;

  return (
    <I13nHeader
      className={classNames(className, 'W(100%) D(f) Ai(c) Jc(sb)')}
      i13nModel={{ category: I13N_CATEGORY_LOGIN, label: 'MobileHeader' }}
    >
      <TinderLogo
        className="W(100px) Mstart(20px) My(16px)"
        type={isOverlay ? 'white' : 'default'}
      />
      <div className="Mend(20px)">
        <ClickableDiv onClick={onMenuClick}>
          <HamburgerIcon
            className={classNames({
              'C($c-ds-text-primary-overlay)': isOverlay,
              'C($c-ds-text-secondary)': !isOverlay,
            })}
          />
        </ClickableDiv>
      </div>
    </I13nHeader>
  );
};

export default memo(PageLayoutMobileHeader);
